import React, { FC, useState } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { useVrmPurchaseRoDetailsModel } from "../vrmBillPurchaseRoModel";
import { Description } from "@/components/YhBox/Description";
import { useVrmSaleRoDetailModel } from "../../vrmBillSaleRo/vrmBillSaleRoModel"
import useNavModel, { RouterParamType } from '@/model/navModel';
import { Button } from 'antd';

export const TopButs: FC<RouterParamType> = ({ id, mode, IFormRef }) => {
    const { detailLookForm: { returnCode, status } } = useVrmPurchaseRoDetailsModel();
    const { getVrmTreeNodeName } = useVrmSaleRoDetailModel();
    const { selectedNavId, replaceNav, findNav, getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const goBack = () => {
        if (detailsInfo.parentInfo && detailsInfo.parentInfo.selectedNavId) {
            replaceNav(selectedNavId, detailsInfo.parentInfo.selectedNavId);
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>
    const orderStatu: IDescription[] = [
        {
            label: "采购退货单",
            value: returnCode as string ?? "暂无",
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: "状态",
            value: getVrmTreeNodeName(status as string) ?? "暂无",
            color: DescriptionColorEnum.green,
            status: true
        }
    ]

    return (
        <YhBox title={<>
            {orderStatu.map((item, index) => <Description key={index} {...item} />)}
        </>}
            action={action}
            style={{ paddingBottom: 0, marginBottom: "15px" }}
        />
    )
}